export function sendMarketingEvent(name, properties = {}) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content

  return fetch("/marketing_events", {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": token
    },
    body: JSON.stringify({ event: name, properties: properties })
  }).catch(() => {})
}
